<template>
  <div>
    <v-card flat class="pa-3 mt-2">
      <v-toolbar dense dark color="primary">
        <v-toolbar-title><h4 class="font-weight-light">LIST OF KAAGAPAY</h4></v-toolbar-title>
      </v-toolbar>
      <v-row>
        <v-col
          md="12"
          cols="12"
        ></v-col>
        <v-col
          md="6"
          cols="12"
        >
          <v-select
            v-model="month_of"
            class="mx-3"
            :items="month_of_items"
            item-value="month_of"
            item-text="month_of"
            label="Month Of"
            required
            @change="monthly_remittances"
            dense
          ></v-select>
        </v-col>
      </v-row>
      <v-card-text>
        <v-simple-table dense>
          <template v-slot:top>
            <v-toolbar flat>
              <span class="headline font-weight-light ">
                                                Print
                                                <v-icon
                                                  class="mr-2"
                                                  color="warning"
                                                  @click="print_list_of_service()"
                                                >
                                                {{ icons.mdiPrinter }}
                                                </v-icon>
                                            </span>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-toolbar-title class="font-weight-light">Total Amount:
                {{ total_amount }}
              </v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-toolbar-title class="font-weight-light">Total:
                {{ total_count }}
              </v-toolbar-title>
            </v-toolbar>
          </template>
          <template v-slot:default>
            <thead>
            <tr>
              <th class="text-uppercase">KMF#</th>
              <th class="text-center text-uppercase">Name</th>
              <th class="text-center text-uppercase">Date of Birth</th>
              <th class="text-center text-uppercase">Age</th>
              <th class="text-center text-uppercase">Effective Date</th>
              <th class="text-center text-uppercase">Gender</th>
              <th class="text-center text-uppercase">Religion</th>
              <th class="text-center text-uppercase">Agent Name</th>
              <th class="text-center text-uppercase">Address</th>
              <th class="text-center text-uppercase">Status</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in list_of_kaagapay_items" :key="item.id">
              <td>{{ item.kmf_no }}</td>
              <td class="text-center">
                {{ item.last_name + ', ' + item.first_name + ' ' + item.middle_name }}
              </td>
              <td class="text-center">
                {{ item.date_of_birth }}
              </td>
              <td class="text-center">
                {{ item.age }}
              </td>
              <td class="text-center">
                {{ item.effective_date }}
              </td>
              <td class="text-center">
                {{ item.gender }}
              </td>
              <td class="text-center">
                {{ item.religion }}
              </td>
              <td class="text-center">
                {{ item.sales_agent.last_name + ', ' + item.sales_agent.first_name }}
              </td>
              <td class="text-center">
                {{ item.address }}
              </td>
              <td class="text-center">
                <v-chip color="success" v-if="item.paid">PAID</v-chip>
                <v-chip color="error" v-else>UNPAID</v-chip>
              </td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
    <snack-bar-dialog :snackbar_flag="this.snackbar" :color="this.snackbar_color"
                      :snackbar_text="this.snackbar_text"/>
  </div>
</template>

<script>
import {mdiAlertOutline, mdiCloudUploadOutline, mdiPrinter} from '@mdi/js'
import {mapGetters, mapActions} from 'vuex'
import moment from 'moment'
import snackBarDialog from '@/components/dialogs/notifications_dialog/Snackbar'

const initialState = () => {
  return {
    total_amount: '0',
    total_count: '0',
    month_of: '',
    month_of_items: [],

    list_of_kaagapay_items: [],
    is_deleting: false,
  }
}
export default {
  components: {
    snackBarDialog,
  },
  setup() {
    return {
      icons: {
        mdiAlertOutline,
        mdiCloudUploadOutline,
        mdiPrinter,
      },
    }
  },
  created() {
    this.get_transaction_month_history({
      branch_id: this.branch_id,
    })
      .then(response => {
        this.month_of_items = response.data
      })
      .catch(error => {
        console.log(error)
      })
  },
  data() {
    return initialState()
  },
  computed: {
    ...mapGetters('form_rules', ['rules']),
    ...mapGetters('system_data', ['snackbar', 'snackbar_color', 'snackbar_text', 'company_logo']),
    ...mapGetters('authentication', ['branch_id', 'month_start', 'month_end', 'user_id', 'branch_address', 'branch_contact_no', 'branch']),
  },
  methods: {
    ...mapActions('system_data', ['change_snackbar']),
    ...mapActions('transaction_months_history', ['get_transaction_month_history']),
    ...mapActions('kaagapay', ['get_list_of_kaagapay']),
    monthly_remittances() {
      const data = new FormData()
      data.append('branch_id', this.branch_id)
      data.append('month_of', this.month_of)
      this.get_list_of_kaagapay(data)
        .then(response => {
          this.list_of_kaagapay_items = response.data[0].data
          this.total_count = response.data[0].total_count
          this.total_amount = response.data[0].total_amount
        })
        .catch(error => {
          console.log(error)
        })
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    print_list_of_service() {
      var imgData = this.company_logo
      var payments_array = []
      var data_array = []
      var data = 'LIST OF KAAGAPAY'
      var month = this.month_of
      data_array = [60, 120, 50, 30, 50, 40, 60, 50, 180, 40]
      payments_array.push(
        [
          {text: 'KMF#', alignment: 'center', style: 'label'},
          {text: 'Name', alignment: 'center', style: 'label'},
          {text: 'Date of Birth', alignment: 'center', style: 'label'},
          {text: 'Age', alignment: 'center', style: 'label'},
          {text: 'Effective Date', alignment: 'center', style: 'label'},
          {text: 'Gender', alignment: 'center', style: 'label'},
          {text: 'Religion', alignment: 'center', style: 'label'},
          {text: 'Occupation', alignment: 'center', style: 'label'},
          {text: 'Address', alignment: 'center', style: 'label'},
          {text: 'Status', alignment: 'center', style: 'label'},
        ]
      )
      if (this.list_of_kaagapay_items.length > 0) {
        this.list_of_kaagapay_items.forEach(function (item) {
          payments_array.push(
            [
              {text: item.kmf_no, alignment: 'left'},
              {
                text: item.last_name + ', ' + item.first_name + ' ' + item.middle_name,
                alignment: 'left'
              },
              {text: item.date_of_birth, alignment: 'left'},
              {text: item.age, alignment: 'left'},
              {text: item.effective_date, alignment: 'left'},
              {text: item.gender, alignment: 'left'},
              {text: item.religion, alignment: 'left'},
              {text: item.occupation, alignment: 'left'},
              {text: item.address, alignment: 'left'},
              {text: item.paid===1?'PAID':'UNPAID', alignment: 'left'},
            ]
          )
        })
      } else {
        payments_array.push(
          [
            '----',
            '----',
            '----',
            '----',
            '----',
            '----',
            '----',
            '----',
            '----',
            '----',
          ]
        )
      }


      //call pdfmake
      var pdfMake = require('pdfmake/build/pdfmake.js')
      if (pdfMake.vfs == undefined) {
        var pdfFonts = require('pdfmake/build/vfs_fonts.js')
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
      }
      var docDefinition = {
        pageOrientation: 'landscape',
        content: [
          {
            columns: [
              {image: imgData, width: 54, height: 54, style: 'logo'},
              {
                stack: [
                  'GOODLIFE MEMORIAL CHAPEL CO.',
                  {text: this.branch_address, style: 'subheader'},
                  {
                    text: 'S.E.C No. PG201636035 TEL #: (082)333-1809 CONTACT NO.: ' + this.branch_contact_no,
                    style: 'subheader'
                  },
                ],
                style: 'header'
              },
            ]
          },
          {text: data, style: 'title'},
          '==============================================================================',
          {text: 'Printed as of: ' + moment().format('MMMM D, YYYY'), style: 'printed_label'},
          {text: 'Branch: ' + this.branch, style: 'main_info'},
          {text: 'Month of: ' + month, style: 'main_info'},
          ' ',
          {
            style: 'tableExample',
            color: '#444',
            table: {
              widths: data_array,
              body: payments_array,
            },
            layout: {
              fillColor: function (rowIndex) {
                return (rowIndex === 0) ? '#CCCCCC' : null;
              },
            },
          },
          {
            stack: [
              {
                columns: [
                  {text: 'Received By:', style: 'cashier_top_margin'},
                  {text: ''},
                ]
              },
              {
                columns: [
                  {text: '', style: 'cashier_for'},
                  {text: ''},
                ]
              },
              {
                columns: [
                  {text: '_________________________________', style: 'cashier_line'},
                  {text: ''},
                ]
              },
              {
                columns: [
                  {text: 'Cashier', style: 'cashier_placeholder'},
                  {text: ''},
                ]
              },
            ]
          },
          {
            stack: [
              {
                columns: [
                  {text: 'Verified By: ', style: 'bm_top_margin'},
                  {text: 'Audited By: ', style: 'au_top_margin'},
                ]
              },
              {
                columns: [
                  {text: '', style: 'bm_for'},
                  {text: '', style: 'au_for'},
                ]
              },
              {
                columns: [
                  {text: '_________________________________', style: 'bm_line'},
                  {text: '_________________________________', style: 'au_line'},
                ]
              },
              {
                columns: [
                  {text: 'Chapel Manager', style: 'bm_placeholder'},
                  {text: 'Asst. Auditor', style: 'au_placeholder'},
                ]
              },
            ]
          },

        ],
        footer: {
          columns: [
            {
              text: 'Generated with Goodlife Savings & Credit Cooperative System',
              alignment: 'center',
              style: 'tableExample'
            }
          ]
        },
        styles: {
          header: {
            fontSize: 21,
            bold: true,
            alignment: 'left',
            margin: [6, 6, 0, 20]//[left, top, right, bottom]
          },
          subheader: {
            fontSize: 10
          },
          title: {
            fontSize: 15,
            alignment: 'center',
          },
          logo: {
            alignment: 'center',
            margin: [0, 0, 0, 0]//[left, top, right, bottom]
          },
          printed_label: {
            alignment: 'right',
            fontSize: 9,
            margin: [0, 4, 0, 0]//[left, top, right, bottom]
          },
          main_info: {
            margin: [0, 2, 0, 2],
            fontSize: 10,
          },
          sub_info: {
            margin: [0, 2, 0, 2],
            fontSize: 8,
          },
          tableExample: {
            fontSize: 9,
          },

          aa_top_margin: {
            margin: [0, 10, 0, 0],
            alignment: 'left',
            fontSize: 7,
          },
          cashier_top_margin: {
            margin: [0, 10, 0, 0],
            alignment: 'left',
            fontSize: 7,
          },
          bm_top_margin: {
            margin: [0, 10, 0, 0],
            alignment: 'left',
            fontSize: 7,
          },
          cs_top_margin: {
            margin: [0, 10, 0, 0],
            alignment: 'left',
            fontSize: 7,
          },
          aa_line: {
            margin: [0, 0, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          cashier_line: {
            margin: [0, 0, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          cs_line: {
            margin: [0, 0, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          bm_line: {
            margin: [0, 0, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          aa_placeholder: {
            margin: [15, 2, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          aa_for: {
            margin: [0, 15, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          cs_for: {
            margin: [2, 15, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          cashier_for: {
            margin: [3, 15, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          bm_for: {
            margin: [3, 15, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          cashier_placeholder: {
            margin: [26, 2, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          cs_placeholder: {
            margin: [2, 2, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          bm_placeholder: {
            margin: [5, 2, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          au_top_margin: {
            margin: [0, 10, 0, 0],
            alignment: 'left',
            fontSize: 7,
          },
          au_placeholder: {
            margin: [2, 2, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          au_for: {
            margin: [2, 15, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          au_line: {
            margin: [0, 0, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
        },
      }
      pdfMake.createPdf(docDefinition).open();
    },
  },
}
</script>
